module.exports = __webpack_public_path__ + "img/multiple_chp.ea5d79bc.png";